var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "header-titre" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "wrap-titre" }, [
          _c(
            "h1",
            { staticClass: "titre" },
            [!_vm.form.showPrivate ? _vm._t("titre") : _vm._t("titre-prive")],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.isLogged
          ? _c("div", { staticClass: "head-cta" }, [
              _c("div", { staticClass: "switch-wrap" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.showPrivate,
                      expression: "form.showPrivate",
                    },
                  ],
                  attrs: { type: "checkbox", id: "private" },
                  domProps: {
                    checked: Array.isArray(_vm.form.showPrivate)
                      ? _vm._i(_vm.form.showPrivate, null) > -1
                      : _vm.form.showPrivate,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.form.showPrivate,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, "showPrivate", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "showPrivate",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "showPrivate", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "private" } }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [_vm._t("swith-label")],
                    2
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "documentation" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("section", { staticClass: "filters" }, [
            _c(
              "div",
              { staticClass: "wrap-head-filters" },
              [
                !_vm.breakpointDownMd
                  ? _c(
                      "ul",
                      { staticClass: "filtre-taaf-rnn" },
                      _vm._l(_vm.filters, function (item, index) {
                        return _c("li", [
                          _c(
                            "a",
                            {
                              class: { active: _vm.form.taxoId === item.id },
                              attrs: { href: "" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.filtreSite(item.id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.breakpointDownMd
                  ? _c("custom-select", {
                      staticClass: "mobile-custom-select",
                      attrs: {
                        "value-field": "id",
                        "label-field": "label",
                        options: _vm.filters,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.filtreSite(null, true)
                        },
                      },
                      model: {
                        value: _vm.form.taxoId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taxoId", $$v)
                        },
                        expression: "form.taxoId",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-select-year" },
                  [
                    _c("p", [_vm._v("Année :")]),
                    _vm._v(" "),
                    _c("custom-select", {
                      attrs: { options: _vm.years },
                      on: {
                        change: function ($event) {
                          return _vm.updateSelect()
                        },
                      },
                      model: {
                        value: _vm.activeYear,
                        callback: function ($$v) {
                          _vm.activeYear = $$v
                        },
                        expression: "activeYear",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { action: "" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmit()
                  },
                },
              },
              [
                _c("div", { staticClass: "form-item word-search" }, [
                  _c("span", {
                    staticClass: "icon-arrow-right",
                    on: {
                      click: function ($event) {
                        return _vm.formSubmit()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.word,
                        expression: "form.word",
                      },
                    ],
                    attrs: {
                      type: "text",
                      name: "word",
                      id: "word",
                      placeholder: "Recherche par mot-clés",
                    },
                    domProps: { value: _vm.form.word },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "word", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loader-wrap" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { attrs: { id: "goto-result" } }),
          _vm._v(" "),
          _c(
            "transition-group",
            {
              staticClass: "list-wrap",
              attrs: { tag: "div", css: false },
              on: { "before-enter": _vm.beforeEnter, enter: _vm.enter },
            },
            _vm._l(_vm.result, function (item, index) {
              return _c(
                "article",
                {
                  key: "key_" + index,
                  staticClass: "item",
                  class: { focus: _vm.form.page === 1 && index === 0 },
                  attrs: { "data-index": index },
                  on: {
                    click: function ($event) {
                      return _vm.openDownload(index)
                    },
                  },
                },
                [
                  item.imgUrl
                    ? _c("div", {
                        staticClass: "img",
                        style: "background-image: url(" + item.imgUrl + ")",
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description",
                      class: { "mobile-hide": _vm.hideDesc(index) },
                    },
                    [
                      _c("h2", {
                        staticClass: "titre",
                        domProps: { innerHTML: _vm._s(item.title) },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "rte",
                        domProps: {
                          innerHTML: _vm._s(_vm.getHtml(item.summary_html)),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "type-text" }, [
                        _vm._v(_vm._s(item.category)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "type" }, [
                    _c("p", { staticClass: "type-text" }, [
                      _vm._v(_vm._s(item.category)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cta",
                      class: { opened: _vm.showLinksWrap },
                    },
                    [
                      item.fileUrls.length === 1
                        ? _c(
                            "a",
                            {
                              staticClass: "simple",
                              attrs: {
                                href: item.fileUrls[0].url,
                                target: "_blank",
                              },
                            },
                            [_c("span", { staticClass: "icon-download" })]
                          )
                        : _c(
                            "div",
                            { staticClass: "double-wrap" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "double",
                                  attrs: { href: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.openDownload(index)
                                    },
                                  },
                                },
                                [_c("span", { staticClass: "icon-download" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "transition",
                                { attrs: { name: "link-docu" } },
                                [
                                  _vm.showLinksWrap &&
                                  index === _vm.activeIndex &&
                                  !_vm.breakpointDownMd
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "links-wrap",
                                          on: {
                                            mouseleave: function ($event) {
                                              return _vm.hideDownload()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: item.fileUrls[0].url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.fileUrls[0].category
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", {
                                                staticClass: "icon-download",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: item.fileUrls[1].url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.fileUrls[1].category
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", {
                                                staticClass: "icon-download",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade-q" } }, [
                    _vm.showLinksWrap &&
                    index === _vm.activeIndex &&
                    _vm.breakpointDownMd
                      ? _c(
                          "div",
                          {
                            staticClass: "mobile-download",
                            class: { simple: item.fileUrls.length === 1 },
                          },
                          [
                            _c("a", { attrs: { href: item.fileUrls[0].url } }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(_vm._s(item.fileUrls[0].category)),
                              ]),
                            ]),
                            _vm._v(" "),
                            item.fileUrls[1]
                              ? _c(
                                  "a",
                                  { attrs: { href: item.fileUrls[1].url } },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v(_vm._s(item.fileUrls[1].category)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.result && _vm.result.length === 0
            ? _c("p", { staticClass: "no-results" }, [_vm._t("no-results")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          !_vm.loading && _vm.showPagination
            ? _c("pagination", {
                attrs: {
                  pagination: _vm.pagination,
                  params: _vm.form,
                  offset: 2,
                },
                on: { paginate: _vm.formSubmit },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "switch" }, [_c("span")])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }